import React from "react";
import { Card, CardContent, Divider, Container, AppBar, Typography, Grow, Grid } from "@mui/material";
import Pagination from "@mui/material/Pagination";

// CSS
import "./TakingTestQuestionNavigation.css";

const TakingTestQuestionNavigation = ({ totalQuestions }) => {
   // Returns current question selected by the user.
   function handleChange(event, value) {
      // console.log("Current Question Selected: ", {value})
      // Based on the value, we can display the question using the CSS display property.
      // The id of the question card to be selected are generated by this dynamic nomenclature: taking-test-question-card-number-${index} (with index being the question number).
      // For example, if the value is 1, we can display the first question (Question 1 is the default displayed question).

      // Hide all the question cards.
      for (let i = 0; i < totalQuestions; i++) {
         let hideQuestion = document.getElementById(`taking-test-question-card-number-${i}`);
         hideQuestion.classList.add("hidden");
      }

      // Get the question card element to show based on the pagination component value.
      let showQuestion = document.getElementById(`taking-test-question-card-number-${value - 1}`);
      // Show the question card.
      showQuestion.classList.remove("hidden");
   }

   return (
      <div className="taking-test-question-navigation-container">
         <Card display="flex" allignItems="flex-start" elevation="5">
            <Pagination count={totalQuestions} defaultPage={1} size="large" onChange={handleChange} />
         </Card>
      </div>
   );
};

export default TakingTestQuestionNavigation;
